export const mixin = {
  data () {
    return {
      columnList: [],
      filterColumn: [],
      filterColumnv: [],
      filterColumnss: [],
      componentesd: {
        header: {
          cell: (h, props, children) => {
            const { key, ...restProps } = props
            const col = this.filterColumn.find(col => {
              const k = col.dataIndex || col.key
              return k === key
            })

            if (!col || !col.width) {
              return h('th', { ...restProps }, [...children])
            }

            const dragProps = {
              key: col.dataIndex || col.key,
              class: 'table-draggable-handle',
              attrs: {
                w: 10,
                x: col.width,
                z: 1,
                axis: 'x',
                draggable: true,
                resizable: false
              },
              on: {
                dragging: (x, y) => {
                  col.width = Math.max(x, 1)
                  if (this.columnv) {
                    this.columnv.forEach((item, index) => {
                      if (item.dataIndex === col.dataIndex) {
                        this.$set(this.columnv[index], 'width', col.width)
                      }
                    })
                  }
                }
              }
            }
            const drag = h('vue-draggable-resizable', { ...dragProps })
            return h('th', { ...restProps, class: 'resize-table-th' }, [...children, drag])
          }
        }
      },
      componentesds: {
        header: {
          cell: (h, props, children) => {
            const { key, ...restProps } = props
            const col = this.filterColumnss.find(col => {
              const k = col.dataIndex || col.key
              return k === key
            })

            if (!col || !col.width) {
              return h('th', { ...restProps }, [...children])
            }

            const dragProps = {
              key: col.dataIndex || col.key,
              class: 'table-draggable-handle',
              attrs: {
                w: 10,
                x: col.width,
                z: 1,
                axis: 'x',
                draggable: true,
                resizable: false
              },
              on: {
                dragging: (x, y) => {
                  col.width = Math.max(x, 1)
                  if (this.columnv) {
                    this.columnv.forEach((item, index) => {
                      if (item.dataIndex === col.dataIndex) {
                        this.$set(this.columnv[index], 'width', col.width)
                      }
                    })
                  }
                }
              }
            }
            const drag = h('vue-draggable-resizable', { ...dragProps })
            return h('th', { ...restProps, class: 'resize-table-th' }, [...children, drag])
          }
        }
      }
    }
  },
  computed: {
    checkColumn: function () {
      return this.columns.map(item => item.title)
    },
    checkColumns: function () {
      return this.columnss.map(item => item.title)
    }
  },
  methods: {
    getColumns (tableCode) {
      this.$putJson('/dynamicTable/update', { tableCode: tableCode, tableField: this.columnList.join(',') }).then(res => {
        this.columnList = res.data.data.split(',')
      })
      const columns = this.columns
      // 核心部分，数组过滤循环遍历columns，如果选择的值中包含dataIndex则为true并暴露出去，反之亦然
      this.filterColumn = columns.filter(item => {
        if (this.columnList.includes(item.title)) {
          // 当暴露值为true时，循环遍历的值会赋给filterValue
          return true
        }
        return false
      })
      if (this.columnv) {
        const columnv = this.columnv
        this.filterColumnv = columnv.filter(item => {
          if (this.columnList.includes(item.title)) {
            // 当暴露值为true时，循环遍历的值会赋给filterValue
            return true
          }
          return false
        })
      }
      if (this.columnss) {
        const columnss = this.columnss
        this.filterColumnss = columnss.filter(item => {
          if (this.columnList.includes(item.title)) {
            // 当暴露值为true时，循环遍历的值会赋给filterValue
            return true
          }
          return false
        })
      }
    },
    geTableColumn (tableCode) {
      this.$get(`/dynamicTable/${tableCode}`).then(res => {
        if (!res.data.data) {
          this.getTable(tableCode)
        } else {
          this.columnList = res.data.data.split(',')
          this.filterColumn = this.columns.filter(item => this.columnList.includes(item.title))
          if (this.columnv) {
            this.filterColumnv = this.columnv.filter(item => this.columnList.includes(item.title))
          }
          if (this.columnss) {
            this.filterColumnss = this.columnss.filter(item => this.columnList.includes(item.title))
          }
        }
      })
    },
    getTable (tableCode) {
      if (tableCode === 'customerManages' || tableCode === 'paymentPlans') {
        // ID,附件,金额,对应项目,对应采购单,供应商,计划付款日期,期次,付款,收票,实际付款日,所有者,审核状态,操作
        this.$postJson('/dynamicTable/add', { tableCode: tableCode, tableField: this.columnss.map(item => item.title).join(',') }).then(res => {
          if (res.data.status) {
            this.columnList = res.data.data.split(',')
            this.filterColumn = this.columns.filter(item => this.columnList.includes(item.title))
            if (this.columnss) {
              this.filterColumnss = this.columnss.filter(item => this.columnList.includes(item.title))
            }
            if (this.columnv) {
              this.filterColumnv = this.columnv.filter(item => this.columnList.includes(item.title))
            }
          }
        })
      } else {
        // ID,附件,金额,对应项目,对应采购单,供应商,计划付款日期,期次,付款,收票,实际付款日,所有者,审核状态,操作
        this.$postJson('/dynamicTable/add', { tableCode: tableCode, tableField: this.columns.map(item => item.title).join(',') }).then(res => {
          if (res.data.status) {
            this.columnList = res.data.data.split(',')
            this.filterColumn = this.columns.filter(item => this.columnList.includes(item.title))
            if (this.columnss) {
              this.filterColumnss = this.columnss.filter(item => this.columnList.includes(item.title))
            }
            if (this.columnv) {
              this.filterColumnv = this.columnv.filter(item => this.columnList.includes(item.title))
            }
          }
        })
      }
    },
    checkChange (checked) {
      if (checked.includes('操作')) {
        // 初始是默认全选的，假设此刻点击了name的选择框
        this.columnList = checked
      } else {
        this.$message.warning('禁止选择操作列')
        this.columnList.push('操作')
        return true
      }
    },
    // 失败项目、已完成项目
    checkChangeed (checked) {
      if (checked.includes('立项日期')) {
        // 初始是默认全选的，假设此刻点击了name的选择框
        this.columnList = checked
      } else {
        this.$message.warning('禁止选择该列')
        this.columnList.push('立项日期')
        return true
      }
    },
    // 资产统计
    checkChangeeded (checked) {
      if (checked.includes('登记日期')) {
        // 初始是默认全选的，假设此刻点击了name的选择框
        this.columnList = checked
      } else {
        this.$message.warning('禁止选择该列')
        this.columnList.push('登记日期')
        return true
      }
    },
    // 销售业绩统计
    checkChangeededs (checked) {
      if (checked.includes('盈亏')) {
        // 初始是默认全选的，假设此刻点击了name的选择框
        this.columnList = checked
      } else {
        this.$message.warning('禁止选择该列')
        this.columnList.push('盈亏')
        return true
      }
    },
    onFilterDropdownVisibleChange (e, tableCode) {
      if (!e) {
        this.$get(`/dynamicTable/${tableCode}`).then(res => {
          this.columnList = res.data.data.split(',')
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/index.js